import { render, staticRenderFns } from "./unResident.vue?vue&type=template&id=77552a2f&scoped=true"
import script from "./unResident.vue?vue&type=script&lang=js"
export * from "./unResident.vue?vue&type=script&lang=js"
import style0 from "./unResident.vue?vue&type=style&index=0&id=77552a2f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77552a2f",
  null
  
)

export default component.exports